export const types = {
  GET_ALL_PRODUCTS_SUCCESS: 'PRODUCTS/GET_ALL_PRODUCTS_SUCCESS',
  GET_ALL_PRODUCTS_BEGINS: 'PRODUCTS/GET_ALL_PRODUCTS_BEGINS',
  GET_ALL_PRODUCTS_FAILURE: 'PRODUCTS/GET_ALL_PRODUCTS_FAILURE',
  SET_ALL_PRODUCTS: 'PRODUCTS/SET_ALL_PRODUCTS',
  SET_SELECTED_PRODUCT: 'PRODUCTS/SET_SELECTED_PRODUCT',
  GET_SUBPRODUCTS_FROM_PRODUCTS_BEGINS:
    'PRODUCTS/GET_SUBPRODUCTS_FROM_PRODUCTS_BEGINS',
  GET_SUBPRODUCTS_FROM_PRODUCTS_SUCCESS:
    'PRODUCTS/GET_SUBPRODUCTS_FROM_PRODUCTS_SUCCESS',
  GET_SUBPRODUCTS_FROM_PRODUCTS_FAILURE:
    'PRODUCTS/GET_SUBPRODUCTS_FROM_PRODUCTS_FAILURE',
  SET_CURRENT_CREATIVE_PILL: 'PRODUCTS/SET_CURRENT_CREATIVE_PILL',
  GET_HIRED_PRODUCTS_SUCCESS: 'PRODUCTS/GET_HIRED_PRODUCTS_SUCCESS',
  GET_HIRED_PRODUCTS_BEGINS: 'PRODUCTS/GET_HIRED_PRODUCTS_BEGINS',
  GET_HIRED_PRODUCTS_FAILURE: 'PRODUCTS/GET_HIRED_PRODUCTS_FAILURE',
  SET_CLIENT_ALREADY_DEVICE: 'PRODUCTS/SET_CLIENT_ALREADY_DEVICE',
  SET_CAN_OBTAIN_SECOND_DEVICE: 'PRODUCTS/SET_CAN_OBTAIN_SECOND_DEVICE',
  SET_PRODUCT_HIRED_SELECTED: 'PRODUCTS/SET_PRODUCT_HIRED_SELECTED',
  SET_PRODUCT_HIRED_UNIQUE: 'PRODUCTS/SET_PRODUCT_HIRED_UNIQUE',
  SET_PRODUCT_HIRED_IS_OLD_CATALOGUE:
    'PRODUCTS/SET_PRODUCT_HIRED_IS_OLD_CATALOGUE',
  SET_GROUP_OF_PRODUCTS_HIRED: 'PRODUCTS/SET_GROUP_OF_PRODUCTS_HIRED',

  GET_MY_HIRED_PRODUCT_SUCCESS: 'PRODUCTS/GET_MY_HIRED_PRODUCT_SUCCESS',
  GET_MY_HIRED_PRODUCT_FAILURE: 'PRODUCTS/GET_MY_HIRED_PRODUCT_FAILURE',
  GET_MY_HIRED_PRODUCT_BEGINS: 'PRODUCTS/GET_MY_HIRED_PRODUCT_BEGINS',

  SET_URL_PROD_COMPRA: 'PRODUCTS/SET_URL_PROD_COMPRA',
  SET_COMPONENT_PRODUCT: 'PRODUCTS/SET_COMPONENT_PRODUCT',
  SET_BLOCK_ME_INTERESA: 'PRODUCTS/SET_BLOCK_ME_INTERESA',

  SET_HAS_RENDERED_CHANNELS: 'PRODUCTS/SET_HAS_RENDERED_CHANNELS',
  GET_CLIENT_DEMANDS_BY_PRODUCTID_SUCCESS:
    'PRODUCTS/GET_CLIENT_DEMANDS_BY_PRODUCTID_SUCCESS',
  GET_CLIENT_DEMANDS_BY_PRODUCTID_FAILURE:
    'PRODUCTS/GET_CLIENT_DEMANDS_BY_PRODUCTID_FAILURE',
  GET_CLIENT_DEMANDS_BY_PRODUCTID_BEGINS:
    'PRODUCTS/GET_CLIENT_DEMANDS_BY_PRODUCTID_BEGINS',
  GET_PREVENTION_PRODUCT_BEGINS: 'PRODUCTS/GET_PREVENTION_PRODUCT_BEGINS',
  GET_PREVENTION_PRODUCT_SUCCESS: 'PRODUCTS/GET_PREVENTION_PRODUCT_SUCCESS',
  GET_PREVENTION_PRODUCT_FAILURE: 'PRODUCTS/GET_PREVENTION_PRODUCT_FAILURE',

  GET_MY_HIRED_PRODUCT_R2R_PRICE_SUCCESS:
    'PRODUCTS/GET_MY_HIRED_PRODUCT_R2R_PRICE_SUCCESS',
  GET_MY_HIRED_PRODUCT_R2R_PRICE_FAILURE:
    'PRODUCTS/GET_MY_HIRED_PRODUCT_R2R_PRICE_FAILURE',
  GET_MY_HIRED_PRODUCT_R2R_PRICE_BEGINS:
    'PRODUCTS/GET_MY_HIRED_PRODUCT_R2R_PRICE_BEGINS',

  GET_MY_HIRED_PRODUCT_R2R_PRICE_ADITIONAL_SUCCESS:
    'PRODUCTS/GET_MY_HIRED_PRODUCT_R2R_PRICE_ADITIONAL_SUCCESS',
  GET_MY_HIRED_PRODUCT_R2R_PRICE_ADITIONAL_FAILURE:
    'PRODUCTS/GET_MY_HIRED_PRODUCT_R2R_PRICE_ADITIONAL_FAILURE',
  GET_MY_HIRED_PRODUCT_R2R_PRICE_ADITIONAL_BEGINS:
    'PRODUCTS/GET_MY_HIRED_PRODUCT_R2R_PRICE_ADITIONAL_BEGINS',
};

export const initialState = {
  products: null,
  currentSubproducts: null,
  currentCreativePill: null,
  productLandingPage: null,
  productHired: null,
  productHiredUnique: null,
  productHiredIsOldCatalogue: false,
  groupOfProductHired: null,
  myHiredProduct: null,
  urlProdCompra: null,
  componentProduct: null,
  blockMeInteresa: null,
  hasRenderedChannels: false,
  demands: null,
  preventionProduct: null,
  preventionProductState: '',
  hiredProductR2rPriceState: '',
  hiredProductR2rPrice: {},
  hiredProductR2rPriceAditionalState: '',
  hiredProductR2rPriceAditional: {},
  hasClientAlreadyDevice: '',
};

const Fusion = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: action.payload,
        productsState: 'SUCCESS',
      };
    case types.GET_ALL_PRODUCTS_FAILURE:
      return {
        ...state,
        productsState: 'FAILURE',
      };
    case types.GET_ALL_PRODUCTS_BEGINS:
      return {
        ...state,
        productsState: 'FETCHING',
      };
    case types.GET_HIRED_PRODUCTS_SUCCESS:
      return {
        ...state,
        productHired: action.payload,
        productsState: 'SUCCESS',
      };
    case types.GET_HIRED_PRODUCTS_FAILURE:
      return {
        ...state,
        productsState: 'FAILURE',
      };
    case types.GET_HIRED_PRODUCTS_BEGINS:
      return {
        ...state,
        productsState: 'FETCHING',
      };
    case types.SET_ALL_PRODUCTS:
      return JSON.parse(
        JSON.stringify({
          ...state,
          products: action.payload,
        })
      );
    case types.SET_SELECTED_PRODUCT: {
      const groupOfProductsInPayload = state.products.allProducts[action.payload.groupProductKey];

      let { productLandingPage } = state;

      if (action.payload.isParamsApplied && groupOfProductsInPayload) {
        productLandingPage = groupOfProductsInPayload[action.payload.productKey];
      }

      return {
        ...state,
        productLandingPage,
        isParamsApplied: action.payload.isParamsApplied,
        products: {
          ...state.products,
          allProducts: {
            ...state.products.allProducts,
            /**
             * Vuelve a construir el objecto de la familia de productos que se le pasa como
             * payload ("action.payload.groupProductKey"), marcando como "selected" a true el
             * producto que se le pasa como payload ("action.payload.productKey") y dejando los demás
             * productos como "selected" a  false
             */
            [action.payload.groupProductKey]: Object.keys(
              groupOfProductsInPayload
            ).reduce((obj, productKey) => {
              /**
               * Hace la comprobacion para todas las propiedades del objeto que contanga
               * la palabla fusion
               */
              if (productKey.includes('fusion')) {
                obj[productKey] = {
                  ...groupOfProductsInPayload[productKey],
                  selected: action.payload.productKey === productKey,
                };
                /**
                 * Resto de propiedades de la familia
                 */
              } else if (productKey.includes('visible')) {
                obj[productKey] = groupOfProductsInPayload.visible;
              } else if (productKey.includes('categories')) {
                obj[productKey] = groupOfProductsInPayload.categories;
              } else if (productKey.includes('selector')) {
                obj[productKey] = groupOfProductsInPayload.selector;
              } else if (productKey.includes('priceOrder')) {
                obj[productKey] = groupOfProductsInPayload.priceOrder;
              } else if (productKey.includes('id')) {
                obj[productKey] = groupOfProductsInPayload.id;
              }
              return obj;
            }, {}),
          },
        },
      };
    }
    case types.GET_SUBPRODUCTS_FROM_PRODUCTS_BEGINS:
      return {
        ...state,
        productsState: 'FETCHING',
      };
    case types.GET_SUBPRODUCTS_FROM_PRODUCTS_SUCCESS:
      return {
        ...state,
        currentSubproducts: action.payload,
        productsState: 'SUCCESS',
      };
    case types.GET_SUBPRODUCTS_FROM_PRODUCTS_FAILURE:
      return {
        ...state,
        productsState: 'FAILURE',
      };
    case types.SET_CURRENT_CREATIVE_PILL:
      return {
        ...state,
        currentCreativePill: {
          nombreParamCreatividad: action.payload.nombreParamCreatividad,
          valorParamCreatividad: action.payload.valorParamCreatividad,
          tagAliasCreatividad: action.payload.tagAliasCreatividad,
        },
      };
    case types.SET_CLIENT_ALREADY_DEVICE:
      return {
        ...state,
        hasClientAlreadyDevice: action.payload,
      };
    case types.SET_CAN_OBTAIN_SECOND_DEVICE:
      return {
        ...state,
        checkCanObtainSecondDevice: action.payload,
      };
    case types.SET_PRODUCT_CONFIG_SELECTED:
      return {
        ...state,
        productConfigSelected: action.payload,
      };
    case types.SET_PRODUCT_HIRED_SELECTED:
      return {
        ...state,
        productHired: Object.keys(state.productHired).reduce(
          (obj, currentProductKey) => {
            const currentProduct = state.productHired[currentProductKey];

            if (
              currentProduct.product
              && currentProduct.product.alias === action.payload
            ) {
              obj[currentProductKey] = {
                ...currentProduct,
                selected: true,
              };
              return obj;
            }

            if (
              currentProduct.product
              && currentProduct.product.alias !== action.payload
            ) {
              obj[currentProductKey] = {
                ...currentProduct,
                selected: false,
              };
              return obj;
            }

            obj[currentProductKey] = currentProduct;
            return obj;
          },
          {}
        ),
      };
    case types.SET_PRODUCT_HIRED_UNIQUE:
      return {
        ...state,
        productHiredUnique: action.payload,
      };
    case types.SET_PRODUCT_HIRED_IS_OLD_CATALOGUE:
      return {
        ...state,
        productHiredIsOldCatalogue: action.payload,
      };
    case types.SET_GROUP_OF_PRODUCTS_HIRED:
      return {
        ...state,
        groupOfProductHired: action.payload,
      };
    case types.GET_MY_HIRED_PRODUCT_SUCCESS:
      return {
        ...state,
        myHiredProduct: action.payload,
        myHiredProductState: 'SUCCESS',
      };
    case types.GET_MY_HIRED_PRODUCT_FAILURE:
      return {
        ...state,
        myHiredProductState: 'FAILURE',
      };
    case types.GET_MY_HIRED_PRODUCT_BEGINS:
      return {
        ...state,
        myHiredProductState: 'FETCHING',
      };
    case types.SET_URL_PROD_COMPRA:
      return {
        ...state,
        urlProdCompra: action.payload,
      };
    case types.SET_COMPONENT_PRODUCT:
      return {
        ...state,
        componentProduct: action.payload,
      };
    case types.SET_BLOCK_ME_INTERESA:
      return {
        ...state,
        blockMeInteresa: action.payload,
      };
    case types.SET_HAS_RENDERED_CHANNELS:
      return {
        ...state,
        hasRenderedChannels: action.payload,
      };
    case types.GET_CLIENT_DEMANDS_BY_PRODUCTID_SUCCESS:
      return {
        ...state,
        demands: action.demands,
        demandsState: 'SUCCESS',
      };
    case types.GET_CLIENT_DEMANDS_BY_PRODUCTID_FAILURE:
      return {
        ...state,
        demandsState: 'FAILURE',
      };
    case types.GET_CLIENT_DEMANDS_BY_PRODUCTID_BEGINS:
      return {
        ...state,
        demandsState: 'FETCHING',
      };
    case types.GET_PREVENTION_PRODUCT_BEGINS:
      return {
        ...state,
        preventionProductState: 'FETCHING',
      };
    case types.GET_PREVENTION_PRODUCT_SUCCESS: {
      return {
        ...state,
        preventionProductState: 'SUCCESS',
        preventionProduct: action.payload,
      };
    }
    case types.GET_PREVENTION_PRODUCT_FAILURE:
      return {
        ...state,
        preventionProductState: 'FAILURE',
      };
    case types.GET_MY_HIRED_PRODUCT_R2R_PRICE_BEGINS:
      return {
        ...state,
        hiredProductR2rPriceState: 'FETCHING',
      };
    case types.GET_MY_HIRED_PRODUCT_R2R_PRICE_SUCCESS: {
      const newHiredProductR2rPrice = { ...state.hiredProductR2rPrice };
      const { id: idPO } = action.payload;
      if (!newHiredProductR2rPrice[idPO]) {
        newHiredProductR2rPrice[idPO] = action.payload;
        return {
          ...state,
          hiredProductR2rPriceState: 'SUCCESS',
          hiredProductR2rPrice: newHiredProductR2rPrice,
        };
      }

      return {
        ...state,
      };
    }
    case types.GET_MY_HIRED_PRODUCT_R2R_PRICE_FAILURE:
      return {
        ...state,
        hiredProductR2rPriceState: 'FAILURE',
      };
    case types.GET_MY_HIRED_PRODUCT_R2R_PRICE_ADITIONAL_BEGINS:
      return {
        ...state,
        hiredProductR2rPriceAditionalState: 'FETCHING',
      };
    case types.GET_MY_HIRED_PRODUCT_R2R_PRICE_ADITIONAL_SUCCESS: {
      const newHiredProductR2rPriceAditional = {
        ...state.hiredProductR2rPriceAditional,
      };
      const { id: idPO } = action.payload;
      if (!newHiredProductR2rPriceAditional[idPO]) {
        newHiredProductR2rPriceAditional[idPO] = action.payload;
        return {
          ...state,
          hiredProductR2rPriceAditionalState: 'SUCCESS',
          hiredProductR2rPriceAditional: newHiredProductR2rPriceAditional,
        };
      }

      return {
        ...state,
      };
    }
    case types.GET_MY_HIRED_PRODUCT_R2R_PRICE_ADITIONAL_FAILURE:
      return {
        ...state,
        hiredProductR2rPriceAditionalState: 'FAILURE',
      };
    default:
      return { ...state };
  }
};

export const actions = {
  getAllProductsBegins: (params) => ({
    type: types.GET_ALL_PRODUCTS_BEGINS,
    params,
  }),
  getAllProductsSuccess: (data) => ({
    type: types.GET_ALL_PRODUCTS_SUCCESS,
    payload: data,
  }),
  getAllProductsFailure: () => ({ type: types.GET_ALL_PRODUCTS_FAILURE }),
  setAllProducts: (data) => ({ type: types.SET_ALL_PRODUCTS, payload: data }),
  setSelectedProduct: (data) => ({
    type: types.SET_SELECTED_PRODUCT,
    payload: {
      groupProductKey: data.groupProductKey,
      productKey: data.productKey,
    },
  }),
  setSelectedProductFromUrlParams: (data) => ({
    type: types.SET_SELECTED_PRODUCT,
    payload: {
      groupProductKey: data.groupProductKey,
      productKey: data.productKey,
      isParamsApplied: true,
    },
  }),
  setCurrentCreativePill: (data) => ({
    type: types.SET_CURRENT_CREATIVE_PILL,
    payload: data,
  }),
  getSubproductsFromProductsBegins: (params) => ({
    type: types.GET_SUBPRODUCTS_FROM_PRODUCTS_BEGINS,
    params,
  }),
  getSubproductsFromProductsSuccess: (params) => ({
    type: types.GET_SUBPRODUCTS_FROM_PRODUCTS_SUCCESS,
    payload: params,
  }),
  getSubproductsFromProductsFailure: () => ({
    type: types.GET_SUBPRODUCTS_FROM_PRODUCTS_FAILURE,
  }),
  getHiredProductsBegins: () => ({ type: types.GET_HIRED_PRODUCTS_BEGINS }),
  getHiredProductsSuccess: (data) => ({
    type: types.GET_HIRED_PRODUCTS_SUCCESS,
    payload: data,
  }),
  getHiredProductsFailure: () => ({ type: types.GET_HIRED_PRODUCTS_FAILURE }),
  setClientAlreadyDevice: (data) => ({
    type: types.SET_CLIENT_ALREADY_DEVICE,
    payload: data,
  }),

  setCanObtainSecondDevice: (data) => ({
    type: types.SET_CAN_OBTAIN_SECOND_DEVICE,
    payload: data,
  }),
  setProductHiredSelected: (data) => ({
    type: types.SET_PRODUCT_HIRED_SELECTED,
    payload: data,
  }),
  setProductHiredUnique: (data) => ({
    type: types.SET_PRODUCT_HIRED_UNIQUE,
    payload: data,
  }),
  setProductIsOldCatalogue: (data) => ({
    type: types.SET_PRODUCT_HIRED_IS_OLD_CATALOGUE,
    payload: data,
  }),
  setGroupOfProductsHired: (data) => ({
    type: types.SET_GROUP_OF_PRODUCTS_HIRED,
    payload: data,
  }),
  getMyHiredProductBegins: (params) => ({
    type: types.GET_MY_HIRED_PRODUCT_BEGINS,
    params,
  }),
  getMyHiredProductSuccess: (data) => ({
    type: types.GET_MY_HIRED_PRODUCT_SUCCESS,
    payload: data,
  }),
  getMyHiredProductFailure: () => ({
    type: types.GET_MY_HIRED_PRODUCT_FAILURE,
  }),
  setUrlProdCompra: (data) => ({
    type: types.SET_URL_PROD_COMPRA,
    payload: data,
  }),
  setComponentProduct: (data) => ({
    type: types.SET_COMPONENT_PRODUCT,
    payload: data,
  }),
  setBlockMeIntersa: (data) => ({
    type: types.SET_BLOCK_ME_INTERESA,
    payload: data,
  }),
  setHasRenderedChannels: (data) => ({
    type: types.SET_HAS_RENDERED_CHANNELS,
    payload: data,
  }),
  getClientDemandsByProductIdBegins: (params) => ({
    type: types.GET_CLIENT_DEMANDS_BY_PRODUCTID_BEGINS,
    ...params,
  }),
  getClientDemandsByProductIdSuccess: (responseLines, responseFusion) => ({
    type: types.GET_CLIENT_DEMANDS_BY_PRODUCTID_SUCCESS,
    demands: { linesDemands: responseLines, fusionDemands: responseFusion },
  }),
  getClientDemandsByProductIdFailure: () => ({
    type: types.GET_CLIENT_DEMANDS_BY_PRODUCTID_FAILURE,
  }),
  getPreventionProductBegins: (data) => ({
    type: types.GET_PREVENTION_PRODUCT_BEGINS,
    prodCode: data.recomCode,
    promoCode: data.promoCode,
  }),
  getPreventionProductSuccess: (preventionProduct) => ({
    type: types.GET_PREVENTION_PRODUCT_SUCCESS,
    payload: preventionProduct,
  }),
  getPreventionProductFailure: (error) => ({
    type: types.GET_PREVENTION_PRODUCT_FAILURE,
    payload: error,
  }),
  getMyHiredProductR2rPriceBegins: (data) => ({
    type: types.GET_MY_HIRED_PRODUCT_R2R_PRICE_BEGINS,
    params: data,
  }),
  getMyHiredProductR2rPriceSuccess: (data) => ({
    type: types.GET_MY_HIRED_PRODUCT_R2R_PRICE_SUCCESS,
    payload: data,
  }),
  getMyHiredProductR2rPriceFailure: (error) => ({
    type: types.GET_MY_HIRED_PRODUCT_R2R_PRICE_FAILURE,
    payload: error,
  }),
  getMyHiredProductR2rPriceAditionalBegins: (data) => ({
    type: types.GET_MY_HIRED_PRODUCT_R2R_PRICE_ADITIONAL_BEGINS,
    params: data,
  }),
  getMyHiredProductR2rPriceAditionalSuccess: (data) => ({
    type: types.GET_MY_HIRED_PRODUCT_R2R_PRICE_ADITIONAL_SUCCESS,
    payload: data,
  }),
  getMyHiredProductR2rPriceAditionalFailure: (error) => ({
    type: types.GET_MY_HIRED_PRODUCT_R2R_PRICE_ADITIONAL_FAILURE,
    payload: error,
  }),
};

export default Fusion;
